import {
  SET_ACTIVITY_PROPERTY_VALIDITY,
  SET_ACTIVITY_VALIDATIONS,
  ADD_ACTIVITY_VALIDATIONS,
  REMOVE_ACTIVITY_VALIDATIONS,
  REPLACE_ACTIVITY_SECTIONS_VALIDITY
} from '../actions/actionTypes';

const initialState = {
  subSectionsProperties: {},
  sectionsValidState: {},
  isValid: false
};

const errorsReducer = (state = initialState, { type, payload } = {}) => {
  const { validations = [] } = state;
  switch (type) {
    case SET_ACTIVITY_PROPERTY_VALIDITY: {
      const { section, property, isValid } = payload;
      return handleActivityPropertyChange(state, section, property, isValid);
    }
    case SET_ACTIVITY_VALIDATIONS:
      return {
        ...state,
        validations: payload
      };
    case ADD_ACTIVITY_VALIDATIONS: {
      const { code: addCode } = payload;
      /*
      const currentValidation = validations.find((v) => v.key === addCode);
      NOT REQUIRED AS OF NOW
      if (currentValidation) {
        return state;
      }
      */
      return {
        ...state,
        validations: [...validations, { key: addCode }]
      };
    }
    case REMOVE_ACTIVITY_VALIDATIONS: {
      const { code: removeCode } = payload;
      const codesToRemove = removeCode;
      if (!validations.some((v) => codesToRemove.includes(v.key))) {
        return state;
      }
      const newValidations = validations.filter((v) => !codesToRemove.includes(v.key));
      return {
        ...state,
        validations: newValidations
      };
    }
    case REPLACE_ACTIVITY_SECTIONS_VALIDITY: {
      return {
        ...state,
        sectionsValidState: payload.reduce((obj, sectionName) => {
          // Disabling as spread operater is expensive.
          // eslint-disable-next-line no-param-reassign
          obj[sectionName] = false;
          return obj;
        }, {})
      };
    }
    default:
      return state;
  }
};
const handleActivityPropertyChange = (state, section, property, isValid) => {
  const { [section]: subSectionProperties } = state.subSectionsProperties || {};
  const newSubSectionProperties = {
    ...subSectionProperties,
    [property]: isValid
  };
  const newSubSectionsPropertiesState = {
    ...state.subSectionsProperties,
    [section]: newSubSectionProperties
  };
  const newSectionsValidState = {
    ...state.sectionsValidState,
    [section]: getSubSectionValid(newSubSectionsPropertiesState[section])
  };
  return {
    ...state,
    subSectionsProperties: newSubSectionsPropertiesState,
    sectionsValidState: newSectionsValidState,
    isValid: getAllSubsectionsValid(newSectionsValidState)
  };
};

const getAllSubsectionsValid = (newErrors) => {
  let isValid = true;
  Object.keys(newErrors).forEach((key) => {
    isValid = isValid && newErrors[key];
  });
  return isValid;
};
/**
 * Checks if all the object values are true
 * @param {Object} newErrors
 * @returns {Boolean} if form is valid
 */
export const getSubSectionValid = (newErrors) => {
  let isValid = true;
  Object.keys(newErrors).forEach((key) => {
    isValid = isValid && newErrors[key];
  });
  return isValid;
};

export default errorsReducer;
